import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Loading extends Vue {
  @Prop({ default: "purple" })
  public readonly color!: string;

  @Prop({ default: 20 })
  public readonly size!: number;
}
